// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { lightningBolt16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-lightning-bolt': IconLightningBolt;
    }
}

/**
 * The icon component for the 'lightningBolt' icon
 */
export class IconLightningBolt extends Icon {
    public constructor() {
        super(lightningBolt16X16);
    }
}

registerIcon('icon-lightning-bolt', IconLightningBolt);
export const iconLightningBoltTag = 'nimble-icon-lightning-bolt';
